import React, { useCallback, useMemo, useState } from "react";
import { useDisclosure } from "../../../../hooks/useDisclosure";
import { PopupTitle } from "../../../atoms/Popup";
import { ServiceRequestDetail } from "./detail";
import { ChangeStatusSection, CommentsSection, CreateServiceRequestForm, ReassignUserSection } from "./form";
import { ServiceRequestGrid } from "./types";

export type FormType = "add" | "changeStatus" | "assignUser" | "addComment" | "detail";

export const useServiceRequestModal = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [formType, setFormType] = useState<FormType>("add");
  const [selectedRow, setSelectedRow] = useState<ServiceRequestGrid | null>(null);

  const handleOpen = useCallback(
    (type: FormType, row?: ServiceRequestGrid) => {
      setFormType(type);
      setSelectedRow(row);
      onOpen();
    },
    [onOpen]
  );

  const popup = useMemo(
    () => ({
      add: {
        title: <PopupTitle title="Add Service Request" />,
        content: <CreateServiceRequestForm onClose={onClose} />,
        width: 1200,
      },
      changeStatus: {
        title: <PopupTitle title="Change Status" />,
        content: <ChangeStatusSection selectedRow={selectedRow} onSuccess={onClose} />,
        width: 600,
      },
      assignUser: {
        title: <PopupTitle title="Reassign User" />,
        content: <ReassignUserSection selectedRow={selectedRow} onSuccess={onClose} />,
        width: 600,
      },
      addComment: {
        title: <PopupTitle title="Add Comment" />,
        content: <CommentsSection ticketId={selectedRow?.ticketId} />,
        width: 600,
      },
      detail: {
        title: <PopupTitle title="Service Request Detail" />,
        content: <ServiceRequestDetail ticketId={selectedRow?.ticketId} />,
        width: 600,
      },
    }),
    [onClose, selectedRow]
  );

  return { popup, formType, isOpen, handleOpen, onClose };
};
